import type { FilterTagGroup, FilterTagTerm } from '@/types';

// Generated by scripts/generate-frontend-tag-fallbacks.php.
// Do not edit manually; update CP_Tag_Vocabulary instead.

export const FALLBACK_TAG_TERMS: FilterTagTerm[] = [
    {
        "slug": "hero",
        "name": "Hero",
        "group": "role",
        "description": "A primary above-the-fold introduction or lead section.",
        "sortOrder": 10,
        "active": true,
        "count": 0
    },
    {
        "slug": "header",
        "name": "Header",
        "group": "role",
        "description": "A top-of-page structural header distinct from deeper navigation modes.",
        "sortOrder": 20,
        "active": true,
        "count": 0
    },
    {
        "slug": "navigation",
        "name": "Navigation",
        "group": "role",
        "description": "A navigational pattern for moving between destinations or sections.",
        "sortOrder": 30,
        "active": true,
        "count": 0
    },
    {
        "slug": "footer",
        "name": "Footer",
        "group": "role",
        "description": "A bottom-of-page footer with links, contact details, or support info.",
        "sortOrder": 40,
        "active": true,
        "count": 0
    },
    {
        "slug": "testimonial",
        "name": "Testimonial",
        "group": "role",
        "description": "A social-proof pattern centered on quotes, reviews, or endorsements.",
        "sortOrder": 50,
        "active": true,
        "count": 0
    },
    {
        "slug": "team",
        "name": "Team",
        "group": "role",
        "description": "A pattern introducing multiple people, staff, or collaborators.",
        "sortOrder": 60,
        "active": true,
        "count": 0
    },
    {
        "slug": "faq",
        "name": "FAQ",
        "group": "role",
        "description": "A frequently asked questions pattern.",
        "sortOrder": 70,
        "active": true,
        "count": 0
    },
    {
        "slug": "pricing",
        "name": "Pricing",
        "group": "role",
        "description": "A pricing table, plan comparison, or commercial pricing summary.",
        "sortOrder": 80,
        "active": true,
        "count": 0
    },
    {
        "slug": "contact",
        "name": "Contact",
        "group": "role",
        "description": "A contact-focused section with reach-out actions or business contact details.",
        "sortOrder": 90,
        "active": true,
        "count": 0
    },
    {
        "slug": "newsletter",
        "name": "Newsletter",
        "group": "role",
        "description": "An email capture or newsletter subscription pattern.",
        "sortOrder": 100,
        "active": true,
        "count": 0
    },
    {
        "slug": "stats",
        "name": "Stats",
        "group": "role",
        "description": "A key metrics, counters, or data highlight pattern.",
        "sortOrder": 110,
        "active": true,
        "count": 0
    },
    {
        "slug": "logo-cloud",
        "name": "Logo Cloud",
        "group": "role",
        "description": "A logo wall or client/partner logo cluster.",
        "sortOrder": 120,
        "active": true,
        "count": 0
    },
    {
        "slug": "gallery",
        "name": "Gallery",
        "group": "role",
        "description": "A gallery or media grid centered on visual browsing.",
        "sortOrder": 130,
        "active": true,
        "count": 0
    },
    {
        "slug": "portfolio",
        "name": "Portfolio",
        "group": "role",
        "description": "A project, case-study, or work showcase pattern.",
        "sortOrder": 140,
        "active": true,
        "count": 0
    },
    {
        "slug": "feature",
        "name": "Feature",
        "group": "role",
        "description": "A feature overview pattern describing benefits, capabilities, or offerings.",
        "sortOrder": 150,
        "active": true,
        "count": 0
    },
    {
        "slug": "cta",
        "name": "CTA",
        "group": "role",
        "description": "A call-to-action block focused on prompting a next step.",
        "sortOrder": 160,
        "active": true,
        "count": 0
    },
    {
        "slug": "search",
        "name": "Search",
        "group": "role",
        "description": "A search input, search panel, or search-result initiation pattern.",
        "sortOrder": 170,
        "active": true,
        "count": 0
    },
    {
        "slug": "filter",
        "name": "Filter",
        "group": "role",
        "description": "A faceted filter or refinement control pattern.",
        "sortOrder": 180,
        "active": true,
        "count": 0
    },
    {
        "slug": "form",
        "name": "Form",
        "group": "role",
        "description": "A general form or structured input pattern.",
        "sortOrder": 190,
        "active": true,
        "count": 0
    },
    {
        "slug": "login",
        "name": "Login",
        "group": "role",
        "description": "A sign-in pattern.",
        "sortOrder": 200,
        "active": true,
        "count": 0
    },
    {
        "slug": "register",
        "name": "Register",
        "group": "role",
        "description": "A registration or sign-up pattern.",
        "sortOrder": 210,
        "active": true,
        "count": 0
    },
    {
        "slug": "profile",
        "name": "Profile",
        "group": "role",
        "description": "A user, member, or single-person profile pattern.",
        "sortOrder": 220,
        "active": true,
        "count": 0
    },
    {
        "slug": "dashboard",
        "name": "Dashboard",
        "group": "role",
        "description": "A dashboard or control panel layout.",
        "sortOrder": 230,
        "active": true,
        "count": 0
    },
    {
        "slug": "chat",
        "name": "Chat",
        "group": "role",
        "description": "A chat or conversation interface.",
        "sortOrder": 240,
        "active": true,
        "count": 0
    },
    {
        "slug": "table",
        "name": "Table",
        "group": "role",
        "description": "A tabular data layout or comparison table.",
        "sortOrder": 250,
        "active": true,
        "count": 0
    },
    {
        "slug": "timeline",
        "name": "Timeline",
        "group": "role",
        "description": "A timeline, roadmap, or chronological progression pattern.",
        "sortOrder": 260,
        "active": true,
        "count": 0
    },
    {
        "slug": "tabs",
        "name": "Tabs",
        "group": "role",
        "description": "A tabbed information switcher.",
        "sortOrder": 270,
        "active": true,
        "count": 0
    },
    {
        "slug": "accordion",
        "name": "Accordion",
        "group": "role",
        "description": "A collapsible accordion pattern outside strict FAQ usage.",
        "sortOrder": 280,
        "active": true,
        "count": 0
    },
    {
        "slug": "article",
        "name": "Article",
        "group": "role",
        "description": "An article or editorial content pattern for a single narrative block.",
        "sortOrder": 290,
        "active": true,
        "count": 0
    },
    {
        "slug": "blog-list",
        "name": "Blog List",
        "group": "role",
        "description": "A listing pattern for posts, articles, or news entries.",
        "sortOrder": 300,
        "active": true,
        "count": 0
    },
    {
        "slug": "sidebar",
        "name": "Sidebar",
        "group": "role",
        "description": "A sidebar layout or secondary navigation/information column.",
        "sortOrder": 310,
        "active": true,
        "count": 0
    },
    {
        "slug": "popup",
        "name": "Popup",
        "group": "role",
        "description": "A modal, popup, or interruptive overlay pattern.",
        "sortOrder": 320,
        "active": true,
        "count": 0
    },
    {
        "slug": "desktop-menu",
        "name": "Desktop Menu",
        "group": "context",
        "description": "A navigation pattern optimized for desktop layout or hover interaction.",
        "sortOrder": 410,
        "active": true,
        "count": 0
    },
    {
        "slug": "mobile-menu",
        "name": "Mobile Menu",
        "group": "context",
        "description": "A navigation pattern optimized for mobile interaction.",
        "sortOrder": 420,
        "active": true,
        "count": 0
    },
    {
        "slug": "mega-menu",
        "name": "Mega Menu",
        "group": "context",
        "description": "A large, multi-column navigation reveal.",
        "sortOrder": 430,
        "active": true,
        "count": 0
    },
    {
        "slug": "dropdown",
        "name": "Dropdown",
        "group": "context",
        "description": "A compact dropdown reveal used inside navigation or controls.",
        "sortOrder": 440,
        "active": true,
        "count": 0
    },
    {
        "slug": "offcanvas",
        "name": "Offcanvas",
        "group": "context",
        "description": "A side-drawer or off-canvas reveal pattern.",
        "sortOrder": 450,
        "active": true,
        "count": 0
    },
    {
        "slug": "sticky-header",
        "name": "Sticky Header",
        "group": "context",
        "description": "A header or navigation pattern that remains fixed during scroll.",
        "sortOrder": 460,
        "active": true,
        "count": 0
    },
    {
        "slug": "bottom-nav",
        "name": "Bottom Nav",
        "group": "context",
        "description": "A bottom navigation pattern typically used in mobile interfaces.",
        "sortOrder": 470,
        "active": true,
        "count": 0
    },
    {
        "slug": "carousel",
        "name": "Carousel",
        "group": "interaction",
        "description": "A horizontally rotating or paged content pattern.",
        "sortOrder": 510,
        "active": true,
        "count": 0
    },
    {
        "slug": "masonry",
        "name": "Masonry",
        "group": "interaction",
        "description": "A masonry-style uneven multi-column layout.",
        "sortOrder": 520,
        "active": true,
        "count": 0
    },
    {
        "slug": "filterable",
        "name": "Filterable",
        "group": "interaction",
        "description": "A pattern where content can be narrowed by controls or chips.",
        "sortOrder": 530,
        "active": true,
        "count": 0
    },
    {
        "slug": "searchable",
        "name": "Searchable",
        "group": "interaction",
        "description": "A pattern where content can be queried via text search.",
        "sortOrder": 540,
        "active": true,
        "count": 0
    },
    {
        "slug": "scroll-linked",
        "name": "Scroll Linked",
        "group": "interaction",
        "description": "A pattern where state changes are linked to page scroll position.",
        "sortOrder": 550,
        "active": true,
        "count": 0
    },
    {
        "slug": "multi-step",
        "name": "Multi-step",
        "group": "interaction",
        "description": "A stepped flow or progressive sequence pattern.",
        "sortOrder": 560,
        "active": true,
        "count": 0
    },
    {
        "slug": "lead-generation",
        "name": "Lead Generation",
        "group": "purpose",
        "description": "A pattern intended to capture inquiries, signups, or demand.",
        "sortOrder": 610,
        "active": true,
        "count": 0
    },
    {
        "slug": "social-proof",
        "name": "Social Proof",
        "group": "purpose",
        "description": "A pattern reinforcing credibility through adoption, feedback, or use by others.",
        "sortOrder": 620,
        "active": true,
        "count": 0
    },
    {
        "slug": "trust-building",
        "name": "Trust Building",
        "group": "purpose",
        "description": "A pattern that builds confidence, legitimacy, or reassurance.",
        "sortOrder": 630,
        "active": true,
        "count": 0
    },
    {
        "slug": "service-overview",
        "name": "Service Overview",
        "group": "purpose",
        "description": "A pattern summarizing service lines or what a business offers.",
        "sortOrder": 640,
        "active": true,
        "count": 0
    },
    {
        "slug": "product-overview",
        "name": "Product Overview",
        "group": "purpose",
        "description": "A pattern summarizing products, product benefits, or product capabilities.",
        "sortOrder": 650,
        "active": true,
        "count": 0
    },
    {
        "slug": "team-introduction",
        "name": "Team Introduction",
        "group": "purpose",
        "description": "A pattern helping visitors understand who is behind the organization.",
        "sortOrder": 660,
        "active": true,
        "count": 0
    },
    {
        "slug": "contact-conversion",
        "name": "Contact Conversion",
        "group": "purpose",
        "description": "A pattern driving a visitor toward direct outreach or booking.",
        "sortOrder": 670,
        "active": true,
        "count": 0
    },
    {
        "slug": "showcase",
        "name": "Showcase",
        "group": "purpose",
        "description": "A pattern meant to display work, examples, or highlights attractively.",
        "sortOrder": 680,
        "active": true,
        "count": 0
    },
    {
        "slug": "support",
        "name": "Support",
        "group": "purpose",
        "description": "A pattern focused on help, support content, or issue resolution.",
        "sortOrder": 690,
        "active": true,
        "count": 0
    },
    {
        "slug": "trustworthy",
        "name": "Trustworthy",
        "group": "tone",
        "description": "A reliable, reassuring, and confidence-building tone.",
        "sortOrder": 710,
        "active": true,
        "count": 0
    },
    {
        "slug": "professional",
        "name": "Professional",
        "group": "tone",
        "description": "A polished, business-like, and competent tone.",
        "sortOrder": 720,
        "active": true,
        "count": 0
    },
    {
        "slug": "formal",
        "name": "Formal",
        "group": "tone",
        "description": "A more reserved, structured, and institution-like tone.",
        "sortOrder": 730,
        "active": true,
        "count": 0
    },
    {
        "slug": "friendly",
        "name": "Friendly",
        "group": "tone",
        "description": "An approachable, welcoming, and easygoing tone.",
        "sortOrder": 740,
        "active": true,
        "count": 0
    },
    {
        "slug": "playful",
        "name": "Playful",
        "group": "tone",
        "description": "A lively, fun, or cute tone.",
        "sortOrder": 750,
        "active": true,
        "count": 0
    },
    {
        "slug": "premium",
        "name": "Premium",
        "group": "tone",
        "description": "A luxurious, elevated, or high-end tone.",
        "sortOrder": 760,
        "active": true,
        "count": 0
    },
    {
        "slug": "minimal",
        "name": "Minimal",
        "group": "tone",
        "description": "A sparse, clean, and visually restrained tone.",
        "sortOrder": 770,
        "active": true,
        "count": 0
    },
    {
        "slug": "corporate",
        "name": "Corporate",
        "group": "tone",
        "description": "A structured, enterprise, or organization-oriented tone.",
        "sortOrder": 780,
        "active": true,
        "count": 0
    },
    {
        "slug": "editorial",
        "name": "Editorial",
        "group": "tone",
        "description": "A story-driven, publication-like, or magazine-like tone.",
        "sortOrder": 790,
        "active": true,
        "count": 0
    },
    {
        "slug": "warm",
        "name": "Warm",
        "group": "tone",
        "description": "A soft, personable, and emotionally inviting tone.",
        "sortOrder": 800,
        "active": true,
        "count": 0
    },
    {
        "slug": "split-layout",
        "name": "Split Layout",
        "group": "layout",
        "description": "A two-zone composition where content and media, form, or support content sit side by side.",
        "sortOrder": 1010,
        "active": true,
        "count": 0
    },
    {
        "slug": "card-grid",
        "name": "Card Grid",
        "group": "layout",
        "description": "A repeated card-based grid used to compare or browse multiple peer items.",
        "sortOrder": 1020,
        "active": true,
        "count": 0
    },
    {
        "slug": "sidebar-layout",
        "name": "Sidebar Layout",
        "group": "layout",
        "description": "A composition with a persistent side column for navigation, filters, metadata, or secondary content.",
        "sortOrder": 1030,
        "active": true,
        "count": 0
    },
    {
        "slug": "centered-stack",
        "name": "Centered Stack",
        "group": "layout",
        "description": "A vertically stacked composition centered around one main message or action.",
        "sortOrder": 1040,
        "active": true,
        "count": 0
    },
    {
        "slug": "asymmetric-layout",
        "name": "Asymmetric Layout",
        "group": "layout",
        "description": "An intentionally uneven composition with offset, overlapping, or unequal visual regions.",
        "sortOrder": 1050,
        "active": true,
        "count": 0
    },
    {
        "slug": "masonry-grid",
        "name": "Masonry Grid",
        "group": "layout",
        "description": "A staggered grid composition with items of varied height or visual rhythm.",
        "sortOrder": 1060,
        "active": true,
        "count": 0
    },
    {
        "slug": "full-bleed-layout",
        "name": "Full Bleed Layout",
        "group": "layout",
        "description": "A composition where imagery, background, or content intentionally spans the available width.",
        "sortOrder": 1070,
        "active": true,
        "count": 0
    },
    {
        "slug": "bento-grid",
        "name": "Bento Grid",
        "group": "layout",
        "description": "A modular grid of differently sized panels arranged like a dashboard or bento board.",
        "sortOrder": 1080,
        "active": true,
        "count": 0
    },
    {
        "slug": "dark-surface",
        "name": "Dark Surface",
        "group": "visual-style",
        "description": "A pattern dominated by dark backgrounds or dark panels as a visible design system.",
        "sortOrder": 1110,
        "active": true,
        "count": 0
    },
    {
        "slug": "gradient-accent",
        "name": "Gradient Accent",
        "group": "visual-style",
        "description": "A visual treatment that relies on gradient backgrounds, overlays, or accent elements.",
        "sortOrder": 1120,
        "active": true,
        "count": 0
    },
    {
        "slug": "image-led",
        "name": "Image Led",
        "group": "visual-style",
        "description": "A pattern where photography, screenshots, or illustration carries the primary visual emphasis.",
        "sortOrder": 1130,
        "active": true,
        "count": 0
    },
    {
        "slug": "bordered-cards",
        "name": "Bordered Cards",
        "group": "visual-style",
        "description": "A visual system based on clear card boundaries, borders, panels, or boxed sections.",
        "sortOrder": 1140,
        "active": true,
        "count": 0
    },
    {
        "slug": "glass-panel",
        "name": "Glass Panel",
        "group": "visual-style",
        "description": "A translucent, frosted, or glass-like panel treatment used as a visible design motif.",
        "sortOrder": 1150,
        "active": true,
        "count": 0
    },
    {
        "slug": "editorial-whitespace",
        "name": "Editorial Whitespace",
        "group": "visual-style",
        "description": "A publication-like style using generous whitespace, strong rhythm, and restrained content density.",
        "sortOrder": 1160,
        "active": true,
        "count": 0
    },
    {
        "slug": "bold-typography",
        "name": "Bold Typography",
        "group": "visual-style",
        "description": "A visual treatment where oversized, heavy, or expressive typography is a dominant feature.",
        "sortOrder": 1170,
        "active": true,
        "count": 0
    },
    {
        "slug": "soft-pastel",
        "name": "Soft Pastel",
        "group": "visual-style",
        "description": "A soft visual treatment built around low-contrast pastel color surfaces or accents.",
        "sortOrder": 1180,
        "active": true,
        "count": 0
    },
    {
        "slug": "stacks-on-mobile",
        "name": "Stacks On Mobile",
        "group": "responsive-behavior",
        "description": "A layout that intentionally collapses multi-column regions into a vertical mobile stack.",
        "sortOrder": 1210,
        "active": true,
        "count": 0
    },
    {
        "slug": "horizontal-scroll-mobile",
        "name": "Horizontal Scroll Mobile",
        "group": "responsive-behavior",
        "description": "A mobile adaptation that preserves multiple items through horizontal scrolling.",
        "sortOrder": 1220,
        "active": true,
        "count": 0
    },
    {
        "slug": "drawer-on-mobile",
        "name": "Drawer On Mobile",
        "group": "responsive-behavior",
        "description": "A responsive behavior where navigation or controls become a drawer on smaller viewports.",
        "sortOrder": 1230,
        "active": true,
        "count": 0
    },
    {
        "slug": "desktop-mobile-swap",
        "name": "Desktop Mobile Swap",
        "group": "responsive-behavior",
        "description": "A pattern that intentionally swaps major layout, navigation, or interaction variants by viewport.",
        "sortOrder": 1240,
        "active": true,
        "count": 0
    },
    {
        "slug": "legal-intent",
        "name": "Legal Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to law, legal services, compliance, or attorney-oriented discovery scenarios.",
        "sortOrder": 1310,
        "active": true,
        "count": 0
    },
    {
        "slug": "healthcare-intent",
        "name": "Healthcare Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to healthcare, clinic, medical service, or patient-support scenarios.",
        "sortOrder": 1320,
        "active": true,
        "count": 0
    },
    {
        "slug": "restaurant-intent",
        "name": "Restaurant Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to restaurant, dining, cafe, menu, or reservation scenarios.",
        "sortOrder": 1330,
        "active": true,
        "count": 0
    },
    {
        "slug": "education-intent",
        "name": "Education Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to school, course, learning, academy, or training scenarios.",
        "sortOrder": 1340,
        "active": true,
        "count": 0
    },
    {
        "slug": "pet-care-intent",
        "name": "Pet Care Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to pet care, veterinary, grooming, adoption, or animal-service scenarios.",
        "sortOrder": 1350,
        "active": true,
        "count": 0
    },
    {
        "slug": "ecommerce-intent",
        "name": "Ecommerce Intent",
        "group": "industry-intent",
        "description": "A pattern strongly suited to online stores, products, shopping, merchandising, or checkout scenarios.",
        "sortOrder": 1360,
        "active": true,
        "count": 0
    }
];

export const FALLBACK_TAG_GROUPS: FilterTagGroup[] = [
    {
        "slug": "role",
        "name": "Role",
        "description": "What the pattern primarily is.",
        "sortOrder": 10,
        "terms": [
            {
                "slug": "hero",
                "name": "Hero",
                "group": "role",
                "description": "A primary above-the-fold introduction or lead section.",
                "sortOrder": 10,
                "active": true,
                "count": 0
            },
            {
                "slug": "header",
                "name": "Header",
                "group": "role",
                "description": "A top-of-page structural header distinct from deeper navigation modes.",
                "sortOrder": 20,
                "active": true,
                "count": 0
            },
            {
                "slug": "navigation",
                "name": "Navigation",
                "group": "role",
                "description": "A navigational pattern for moving between destinations or sections.",
                "sortOrder": 30,
                "active": true,
                "count": 0
            },
            {
                "slug": "footer",
                "name": "Footer",
                "group": "role",
                "description": "A bottom-of-page footer with links, contact details, or support info.",
                "sortOrder": 40,
                "active": true,
                "count": 0
            },
            {
                "slug": "testimonial",
                "name": "Testimonial",
                "group": "role",
                "description": "A social-proof pattern centered on quotes, reviews, or endorsements.",
                "sortOrder": 50,
                "active": true,
                "count": 0
            },
            {
                "slug": "team",
                "name": "Team",
                "group": "role",
                "description": "A pattern introducing multiple people, staff, or collaborators.",
                "sortOrder": 60,
                "active": true,
                "count": 0
            },
            {
                "slug": "faq",
                "name": "FAQ",
                "group": "role",
                "description": "A frequently asked questions pattern.",
                "sortOrder": 70,
                "active": true,
                "count": 0
            },
            {
                "slug": "pricing",
                "name": "Pricing",
                "group": "role",
                "description": "A pricing table, plan comparison, or commercial pricing summary.",
                "sortOrder": 80,
                "active": true,
                "count": 0
            },
            {
                "slug": "contact",
                "name": "Contact",
                "group": "role",
                "description": "A contact-focused section with reach-out actions or business contact details.",
                "sortOrder": 90,
                "active": true,
                "count": 0
            },
            {
                "slug": "newsletter",
                "name": "Newsletter",
                "group": "role",
                "description": "An email capture or newsletter subscription pattern.",
                "sortOrder": 100,
                "active": true,
                "count": 0
            },
            {
                "slug": "stats",
                "name": "Stats",
                "group": "role",
                "description": "A key metrics, counters, or data highlight pattern.",
                "sortOrder": 110,
                "active": true,
                "count": 0
            },
            {
                "slug": "logo-cloud",
                "name": "Logo Cloud",
                "group": "role",
                "description": "A logo wall or client/partner logo cluster.",
                "sortOrder": 120,
                "active": true,
                "count": 0
            },
            {
                "slug": "gallery",
                "name": "Gallery",
                "group": "role",
                "description": "A gallery or media grid centered on visual browsing.",
                "sortOrder": 130,
                "active": true,
                "count": 0
            },
            {
                "slug": "portfolio",
                "name": "Portfolio",
                "group": "role",
                "description": "A project, case-study, or work showcase pattern.",
                "sortOrder": 140,
                "active": true,
                "count": 0
            },
            {
                "slug": "feature",
                "name": "Feature",
                "group": "role",
                "description": "A feature overview pattern describing benefits, capabilities, or offerings.",
                "sortOrder": 150,
                "active": true,
                "count": 0
            },
            {
                "slug": "cta",
                "name": "CTA",
                "group": "role",
                "description": "A call-to-action block focused on prompting a next step.",
                "sortOrder": 160,
                "active": true,
                "count": 0
            },
            {
                "slug": "search",
                "name": "Search",
                "group": "role",
                "description": "A search input, search panel, or search-result initiation pattern.",
                "sortOrder": 170,
                "active": true,
                "count": 0
            },
            {
                "slug": "filter",
                "name": "Filter",
                "group": "role",
                "description": "A faceted filter or refinement control pattern.",
                "sortOrder": 180,
                "active": true,
                "count": 0
            },
            {
                "slug": "form",
                "name": "Form",
                "group": "role",
                "description": "A general form or structured input pattern.",
                "sortOrder": 190,
                "active": true,
                "count": 0
            },
            {
                "slug": "login",
                "name": "Login",
                "group": "role",
                "description": "A sign-in pattern.",
                "sortOrder": 200,
                "active": true,
                "count": 0
            },
            {
                "slug": "register",
                "name": "Register",
                "group": "role",
                "description": "A registration or sign-up pattern.",
                "sortOrder": 210,
                "active": true,
                "count": 0
            },
            {
                "slug": "profile",
                "name": "Profile",
                "group": "role",
                "description": "A user, member, or single-person profile pattern.",
                "sortOrder": 220,
                "active": true,
                "count": 0
            },
            {
                "slug": "dashboard",
                "name": "Dashboard",
                "group": "role",
                "description": "A dashboard or control panel layout.",
                "sortOrder": 230,
                "active": true,
                "count": 0
            },
            {
                "slug": "chat",
                "name": "Chat",
                "group": "role",
                "description": "A chat or conversation interface.",
                "sortOrder": 240,
                "active": true,
                "count": 0
            },
            {
                "slug": "table",
                "name": "Table",
                "group": "role",
                "description": "A tabular data layout or comparison table.",
                "sortOrder": 250,
                "active": true,
                "count": 0
            },
            {
                "slug": "timeline",
                "name": "Timeline",
                "group": "role",
                "description": "A timeline, roadmap, or chronological progression pattern.",
                "sortOrder": 260,
                "active": true,
                "count": 0
            },
            {
                "slug": "tabs",
                "name": "Tabs",
                "group": "role",
                "description": "A tabbed information switcher.",
                "sortOrder": 270,
                "active": true,
                "count": 0
            },
            {
                "slug": "accordion",
                "name": "Accordion",
                "group": "role",
                "description": "A collapsible accordion pattern outside strict FAQ usage.",
                "sortOrder": 280,
                "active": true,
                "count": 0
            },
            {
                "slug": "article",
                "name": "Article",
                "group": "role",
                "description": "An article or editorial content pattern for a single narrative block.",
                "sortOrder": 290,
                "active": true,
                "count": 0
            },
            {
                "slug": "blog-list",
                "name": "Blog List",
                "group": "role",
                "description": "A listing pattern for posts, articles, or news entries.",
                "sortOrder": 300,
                "active": true,
                "count": 0
            },
            {
                "slug": "sidebar",
                "name": "Sidebar",
                "group": "role",
                "description": "A sidebar layout or secondary navigation/information column.",
                "sortOrder": 310,
                "active": true,
                "count": 0
            },
            {
                "slug": "popup",
                "name": "Popup",
                "group": "role",
                "description": "A modal, popup, or interruptive overlay pattern.",
                "sortOrder": 320,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "context",
        "name": "Context",
        "description": "Where or in what navigation/device context the pattern is used.",
        "sortOrder": 20,
        "terms": [
            {
                "slug": "desktop-menu",
                "name": "Desktop Menu",
                "group": "context",
                "description": "A navigation pattern optimized for desktop layout or hover interaction.",
                "sortOrder": 410,
                "active": true,
                "count": 0
            },
            {
                "slug": "mobile-menu",
                "name": "Mobile Menu",
                "group": "context",
                "description": "A navigation pattern optimized for mobile interaction.",
                "sortOrder": 420,
                "active": true,
                "count": 0
            },
            {
                "slug": "mega-menu",
                "name": "Mega Menu",
                "group": "context",
                "description": "A large, multi-column navigation reveal.",
                "sortOrder": 430,
                "active": true,
                "count": 0
            },
            {
                "slug": "dropdown",
                "name": "Dropdown",
                "group": "context",
                "description": "A compact dropdown reveal used inside navigation or controls.",
                "sortOrder": 440,
                "active": true,
                "count": 0
            },
            {
                "slug": "offcanvas",
                "name": "Offcanvas",
                "group": "context",
                "description": "A side-drawer or off-canvas reveal pattern.",
                "sortOrder": 450,
                "active": true,
                "count": 0
            },
            {
                "slug": "sticky-header",
                "name": "Sticky Header",
                "group": "context",
                "description": "A header or navigation pattern that remains fixed during scroll.",
                "sortOrder": 460,
                "active": true,
                "count": 0
            },
            {
                "slug": "bottom-nav",
                "name": "Bottom Nav",
                "group": "context",
                "description": "A bottom navigation pattern typically used in mobile interfaces.",
                "sortOrder": 470,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "interaction",
        "name": "Interaction",
        "description": "How the pattern behaves or is manipulated.",
        "sortOrder": 30,
        "terms": [
            {
                "slug": "carousel",
                "name": "Carousel",
                "group": "interaction",
                "description": "A horizontally rotating or paged content pattern.",
                "sortOrder": 510,
                "active": true,
                "count": 0
            },
            {
                "slug": "masonry",
                "name": "Masonry",
                "group": "interaction",
                "description": "A masonry-style uneven multi-column layout.",
                "sortOrder": 520,
                "active": true,
                "count": 0
            },
            {
                "slug": "filterable",
                "name": "Filterable",
                "group": "interaction",
                "description": "A pattern where content can be narrowed by controls or chips.",
                "sortOrder": 530,
                "active": true,
                "count": 0
            },
            {
                "slug": "searchable",
                "name": "Searchable",
                "group": "interaction",
                "description": "A pattern where content can be queried via text search.",
                "sortOrder": 540,
                "active": true,
                "count": 0
            },
            {
                "slug": "scroll-linked",
                "name": "Scroll Linked",
                "group": "interaction",
                "description": "A pattern where state changes are linked to page scroll position.",
                "sortOrder": 550,
                "active": true,
                "count": 0
            },
            {
                "slug": "multi-step",
                "name": "Multi-step",
                "group": "interaction",
                "description": "A stepped flow or progressive sequence pattern.",
                "sortOrder": 560,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "purpose",
        "name": "Purpose",
        "description": "Why the pattern exists from a conversion or content perspective.",
        "sortOrder": 40,
        "terms": [
            {
                "slug": "lead-generation",
                "name": "Lead Generation",
                "group": "purpose",
                "description": "A pattern intended to capture inquiries, signups, or demand.",
                "sortOrder": 610,
                "active": true,
                "count": 0
            },
            {
                "slug": "social-proof",
                "name": "Social Proof",
                "group": "purpose",
                "description": "A pattern reinforcing credibility through adoption, feedback, or use by others.",
                "sortOrder": 620,
                "active": true,
                "count": 0
            },
            {
                "slug": "trust-building",
                "name": "Trust Building",
                "group": "purpose",
                "description": "A pattern that builds confidence, legitimacy, or reassurance.",
                "sortOrder": 630,
                "active": true,
                "count": 0
            },
            {
                "slug": "service-overview",
                "name": "Service Overview",
                "group": "purpose",
                "description": "A pattern summarizing service lines or what a business offers.",
                "sortOrder": 640,
                "active": true,
                "count": 0
            },
            {
                "slug": "product-overview",
                "name": "Product Overview",
                "group": "purpose",
                "description": "A pattern summarizing products, product benefits, or product capabilities.",
                "sortOrder": 650,
                "active": true,
                "count": 0
            },
            {
                "slug": "team-introduction",
                "name": "Team Introduction",
                "group": "purpose",
                "description": "A pattern helping visitors understand who is behind the organization.",
                "sortOrder": 660,
                "active": true,
                "count": 0
            },
            {
                "slug": "contact-conversion",
                "name": "Contact Conversion",
                "group": "purpose",
                "description": "A pattern driving a visitor toward direct outreach or booking.",
                "sortOrder": 670,
                "active": true,
                "count": 0
            },
            {
                "slug": "showcase",
                "name": "Showcase",
                "group": "purpose",
                "description": "A pattern meant to display work, examples, or highlights attractively.",
                "sortOrder": 680,
                "active": true,
                "count": 0
            },
            {
                "slug": "support",
                "name": "Support",
                "group": "purpose",
                "description": "A pattern focused on help, support content, or issue resolution.",
                "sortOrder": 690,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "tone",
        "name": "Tone",
        "description": "What kind of brand feeling the pattern suggests.",
        "sortOrder": 50,
        "terms": [
            {
                "slug": "trustworthy",
                "name": "Trustworthy",
                "group": "tone",
                "description": "A reliable, reassuring, and confidence-building tone.",
                "sortOrder": 710,
                "active": true,
                "count": 0
            },
            {
                "slug": "professional",
                "name": "Professional",
                "group": "tone",
                "description": "A polished, business-like, and competent tone.",
                "sortOrder": 720,
                "active": true,
                "count": 0
            },
            {
                "slug": "formal",
                "name": "Formal",
                "group": "tone",
                "description": "A more reserved, structured, and institution-like tone.",
                "sortOrder": 730,
                "active": true,
                "count": 0
            },
            {
                "slug": "friendly",
                "name": "Friendly",
                "group": "tone",
                "description": "An approachable, welcoming, and easygoing tone.",
                "sortOrder": 740,
                "active": true,
                "count": 0
            },
            {
                "slug": "playful",
                "name": "Playful",
                "group": "tone",
                "description": "A lively, fun, or cute tone.",
                "sortOrder": 750,
                "active": true,
                "count": 0
            },
            {
                "slug": "premium",
                "name": "Premium",
                "group": "tone",
                "description": "A luxurious, elevated, or high-end tone.",
                "sortOrder": 760,
                "active": true,
                "count": 0
            },
            {
                "slug": "minimal",
                "name": "Minimal",
                "group": "tone",
                "description": "A sparse, clean, and visually restrained tone.",
                "sortOrder": 770,
                "active": true,
                "count": 0
            },
            {
                "slug": "corporate",
                "name": "Corporate",
                "group": "tone",
                "description": "A structured, enterprise, or organization-oriented tone.",
                "sortOrder": 780,
                "active": true,
                "count": 0
            },
            {
                "slug": "editorial",
                "name": "Editorial",
                "group": "tone",
                "description": "A story-driven, publication-like, or magazine-like tone.",
                "sortOrder": 790,
                "active": true,
                "count": 0
            },
            {
                "slug": "warm",
                "name": "Warm",
                "group": "tone",
                "description": "A soft, personable, and emotionally inviting tone.",
                "sortOrder": 800,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "layout",
        "name": "Layout",
        "description": "The dominant structural composition used by the pattern.",
        "sortOrder": 60,
        "terms": [
            {
                "slug": "split-layout",
                "name": "Split Layout",
                "group": "layout",
                "description": "A two-zone composition where content and media, form, or support content sit side by side.",
                "sortOrder": 1010,
                "active": true,
                "count": 0
            },
            {
                "slug": "card-grid",
                "name": "Card Grid",
                "group": "layout",
                "description": "A repeated card-based grid used to compare or browse multiple peer items.",
                "sortOrder": 1020,
                "active": true,
                "count": 0
            },
            {
                "slug": "sidebar-layout",
                "name": "Sidebar Layout",
                "group": "layout",
                "description": "A composition with a persistent side column for navigation, filters, metadata, or secondary content.",
                "sortOrder": 1030,
                "active": true,
                "count": 0
            },
            {
                "slug": "centered-stack",
                "name": "Centered Stack",
                "group": "layout",
                "description": "A vertically stacked composition centered around one main message or action.",
                "sortOrder": 1040,
                "active": true,
                "count": 0
            },
            {
                "slug": "asymmetric-layout",
                "name": "Asymmetric Layout",
                "group": "layout",
                "description": "An intentionally uneven composition with offset, overlapping, or unequal visual regions.",
                "sortOrder": 1050,
                "active": true,
                "count": 0
            },
            {
                "slug": "masonry-grid",
                "name": "Masonry Grid",
                "group": "layout",
                "description": "A staggered grid composition with items of varied height or visual rhythm.",
                "sortOrder": 1060,
                "active": true,
                "count": 0
            },
            {
                "slug": "full-bleed-layout",
                "name": "Full Bleed Layout",
                "group": "layout",
                "description": "A composition where imagery, background, or content intentionally spans the available width.",
                "sortOrder": 1070,
                "active": true,
                "count": 0
            },
            {
                "slug": "bento-grid",
                "name": "Bento Grid",
                "group": "layout",
                "description": "A modular grid of differently sized panels arranged like a dashboard or bento board.",
                "sortOrder": 1080,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "visual-style",
        "name": "Visual Style",
        "description": "A concrete visual treatment that is more specific than general tone.",
        "sortOrder": 70,
        "terms": [
            {
                "slug": "dark-surface",
                "name": "Dark Surface",
                "group": "visual-style",
                "description": "A pattern dominated by dark backgrounds or dark panels as a visible design system.",
                "sortOrder": 1110,
                "active": true,
                "count": 0
            },
            {
                "slug": "gradient-accent",
                "name": "Gradient Accent",
                "group": "visual-style",
                "description": "A visual treatment that relies on gradient backgrounds, overlays, or accent elements.",
                "sortOrder": 1120,
                "active": true,
                "count": 0
            },
            {
                "slug": "image-led",
                "name": "Image Led",
                "group": "visual-style",
                "description": "A pattern where photography, screenshots, or illustration carries the primary visual emphasis.",
                "sortOrder": 1130,
                "active": true,
                "count": 0
            },
            {
                "slug": "bordered-cards",
                "name": "Bordered Cards",
                "group": "visual-style",
                "description": "A visual system based on clear card boundaries, borders, panels, or boxed sections.",
                "sortOrder": 1140,
                "active": true,
                "count": 0
            },
            {
                "slug": "glass-panel",
                "name": "Glass Panel",
                "group": "visual-style",
                "description": "A translucent, frosted, or glass-like panel treatment used as a visible design motif.",
                "sortOrder": 1150,
                "active": true,
                "count": 0
            },
            {
                "slug": "editorial-whitespace",
                "name": "Editorial Whitespace",
                "group": "visual-style",
                "description": "A publication-like style using generous whitespace, strong rhythm, and restrained content density.",
                "sortOrder": 1160,
                "active": true,
                "count": 0
            },
            {
                "slug": "bold-typography",
                "name": "Bold Typography",
                "group": "visual-style",
                "description": "A visual treatment where oversized, heavy, or expressive typography is a dominant feature.",
                "sortOrder": 1170,
                "active": true,
                "count": 0
            },
            {
                "slug": "soft-pastel",
                "name": "Soft Pastel",
                "group": "visual-style",
                "description": "A soft visual treatment built around low-contrast pastel color surfaces or accents.",
                "sortOrder": 1180,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "responsive-behavior",
        "name": "Responsive Behavior",
        "description": "How the pattern adapts across viewport sizes.",
        "sortOrder": 80,
        "terms": [
            {
                "slug": "stacks-on-mobile",
                "name": "Stacks On Mobile",
                "group": "responsive-behavior",
                "description": "A layout that intentionally collapses multi-column regions into a vertical mobile stack.",
                "sortOrder": 1210,
                "active": true,
                "count": 0
            },
            {
                "slug": "horizontal-scroll-mobile",
                "name": "Horizontal Scroll Mobile",
                "group": "responsive-behavior",
                "description": "A mobile adaptation that preserves multiple items through horizontal scrolling.",
                "sortOrder": 1220,
                "active": true,
                "count": 0
            },
            {
                "slug": "drawer-on-mobile",
                "name": "Drawer On Mobile",
                "group": "responsive-behavior",
                "description": "A responsive behavior where navigation or controls become a drawer on smaller viewports.",
                "sortOrder": 1230,
                "active": true,
                "count": 0
            },
            {
                "slug": "desktop-mobile-swap",
                "name": "Desktop Mobile Swap",
                "group": "responsive-behavior",
                "description": "A pattern that intentionally swaps major layout, navigation, or interaction variants by viewport.",
                "sortOrder": 1240,
                "active": true,
                "count": 0
            }
        ]
    },
    {
        "slug": "industry-intent",
        "name": "Industry Intent",
        "description": "A cautious, public discovery signal for strongly evidenced industry use cases.",
        "sortOrder": 90,
        "terms": [
            {
                "slug": "legal-intent",
                "name": "Legal Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to law, legal services, compliance, or attorney-oriented discovery scenarios.",
                "sortOrder": 1310,
                "active": true,
                "count": 0
            },
            {
                "slug": "healthcare-intent",
                "name": "Healthcare Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to healthcare, clinic, medical service, or patient-support scenarios.",
                "sortOrder": 1320,
                "active": true,
                "count": 0
            },
            {
                "slug": "restaurant-intent",
                "name": "Restaurant Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to restaurant, dining, cafe, menu, or reservation scenarios.",
                "sortOrder": 1330,
                "active": true,
                "count": 0
            },
            {
                "slug": "education-intent",
                "name": "Education Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to school, course, learning, academy, or training scenarios.",
                "sortOrder": 1340,
                "active": true,
                "count": 0
            },
            {
                "slug": "pet-care-intent",
                "name": "Pet Care Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to pet care, veterinary, grooming, adoption, or animal-service scenarios.",
                "sortOrder": 1350,
                "active": true,
                "count": 0
            },
            {
                "slug": "ecommerce-intent",
                "name": "Ecommerce Intent",
                "group": "industry-intent",
                "description": "A pattern strongly suited to online stores, products, shopping, merchandising, or checkout scenarios.",
                "sortOrder": 1360,
                "active": true,
                "count": 0
            }
        ]
    }
];
